module.exports = __webpack_public_path__ + "img/sleeve flounce length.d7e79897.png";